






















































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Component as LoadingSpinner } from '@/components/spinners';
import Infotext from '@/components/parts/infotext';
import ViewsProps from '@/pages/profile/modules/remote-edu/mixins/viewsProps';
import { Info } from '@/pages/profile/components';
import { Top } from '../components';
import {
  Selector,
  CalendarFilter,
  CalendarBlock,
  ListBlock,
  CalendarPopup,
} from './components';
import { ICalendarModule } from './types';
import { CURRENT_MONTH, CURRENT_YEAR, POPUP, ACTIVE } from './consts';

@Component({
  components: {
    Top,
    Selector,
    CalendarFilter,
    LoadingSpinner,
    Infotext,
    CalendarBlock,
    ListBlock,
    CalendarPopup,
    Info,
  },
})
export default class CalendarModule
  extends Mixins(ViewsProps)
  implements ICalendarModule {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<any>;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  isCalendar: boolean = true;
  isPopup: boolean = false;
  month: number = CURRENT_MONTH;
  year: number = CURRENT_YEAR;
  day: string = '';

  get isData(): boolean {
    return !!(this.data.length > 0);
  }

  get monthValue(): string {
    return this.month.toString();
  }

  get monthYear(): string {
    return this.year.toString();
  }

  get popupItems() {
    const { day, items } = this;
    return items.filter(({ date }) => date === day);
  }

  get isNoDate(): boolean {
    return !!this.items.find(({ date }) => !date.length);
  }

  beforeDestroy() {
    this.removeListener();
  }

  addListener() {
    if (document) {
      document.addEventListener('click', this.closePopupOut, false);
    }
  }

  removeListener() {
    if (document) {
      document.removeEventListener('click', this.closePopupOut);
    }
  }

  closePopupOut(e: any) {
    if (
      ![...e.composedPath()].find(
        ({ className }) => className === POPUP || className === ACTIVE
      )
    ) {
      this.closePopup();
    }
  }

  typeContentStyle(value: number) {
    this.isCalendar = !this.isCalendar;
  }

  monthChange(value: string) {
    this.month = parseInt(value, 10);
  }

  yearChange(value: string) {
    this.year = parseInt(value, 10);
  }

  typeChange(value: string) {
    this.$emit('type', value);
  }

  openPopup(day: string, $event: any) {
    this.day = day;
    this.isPopup = true;
    this.addListener();
  }

  closePopup() {
    this.day = '';
    this.isPopup = false;
    this.removeListener();
  }

  prev() {
    if (this.month === 1) {
      this.year = this.year - 1;
      this.month = 12;
    } else {
      this.month = this.month - 1;
    }
  }

  next() {
    if (this.month === 12) {
      this.year = this.year + 1;
      this.month = 1;
    } else {
      this.month = this.month + 1;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/Calendar.vue